import { LoadingService } from './../../services/loading.service';
import { ThrottleClickDirective } from './../../directives/throttle-click.directive';
import {
  Component,
  EventEmitter,
  Input,
  Output,
  OnInit,
  ElementRef,
  OnDestroy,
  ViewChild,
  AfterViewInit,
  inject,
} from '@angular/core';
import { IconName } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'sigecom-action-buttons',
  template: `
    <div
      [ngClass]="{
        'sticky bottom-10 shadow-md z-50 shadow-sigecom-gray border border-sigecom-gray-1 transition-all duration-300':
          isFloating,
        'relative shadow-lg': !isFloating,
      }"
      class="flex justify-between items-center p-4 bg-white rounded-lg mt-4"
    >
      <p *ngIf="textInfo" class="font-bold text-md text-nowrap text-[#bdbdbd] ">
        {{ textInfo }}
      </p>
      <div class="w-full flex justify-end gap-2">
        <ng-content></ng-content>

        <sigecom-button
          type="danger"
          [outlined]="true"
          [title]="cancelTitle"
          [icon]="cancelIcon"
          (buttonClicked)="onCancelClick()"
        />

        <sigecom-button
          *ngIf="!hideSaveButton"
          type="info"
          [outlined]="true"
          [title]="saveTitle"
          [icon]="saveIcon"
          [disabled]="isLoading || isSaveDisabled"
          [submitButton]="true"
          throttleClick
          (throttleClick)="onSaveClick()"
          [throttleTime]="1200"
          [enableLoading]="isLoading"
        />
      </div>
    </div>

    <!-- sentinel vai logo DEPOIS do bloco -->
    <div #sentinel class="h-1"></div>
  `,
})
export class ActionButtonsComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  @Input() textInfo?: string;
  @Input() cancelTitle: string = 'Cancelar';
  @Input() saveTitle: string = 'Salvar';
  @Input() cancelIcon: IconName = 'xmark';
  @Input() saveIcon: IconName = 'check';
  @Input() isSaveDisabled: boolean = false;
  @Input() hideSaveButton: boolean = false;
  @Input() disableFloating: boolean = false;

  @Output() cancelClick: EventEmitter<void> = new EventEmitter();
  @Output() saveClick: EventEmitter<void> = new EventEmitter();

  isLoading: boolean = false;
  isFloating: boolean = false;
  observer?: IntersectionObserver;
  @ViewChild('sentinel') sentinel!: ElementRef;

  private readonly loadingService = inject(LoadingService);

  constructor(private el: ElementRef) {}

  ngOnInit() {
    this.loadingService.isActive.subscribe((e) => {
      this.isLoading = e;
    });
  }

  ngAfterViewInit() {
    if (this.disableFloating) {
      this.isFloating = false;
      return;
    }

    this.observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          // sentinel visível -> não flutua
          this.isFloating = false;
        } else {
          // sentinel fora da viewport -> flutua
          this.isFloating = true;
        }
      },
      {
        root: null,
        threshold: 0,
        rootMargin: '0px 0px -80px 0px', // ativa 80px antes de sumir de vez
      },
    );

    if (this.sentinel?.nativeElement) {
      this.observer.observe(this.sentinel.nativeElement);
    }
  }

  ngOnDestroy(): void {
    this.observer?.disconnect();
  }

  onCancelClick() {
    this.cancelClick.emit();
  }

  onSaveClick() {
    if (this.isLoading || this.isSaveDisabled) return;

    this.saveClick.emit();
  }
}
